import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperPropertySingle() {
    

    const swiper = new Swiper(".property-single__swiper", {
        modules: [Navigation],

        loop: true,
        grabCursor: true,
        speed: 1000,

        navigation: {
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
        },

        // Parallax
        watchSlidesProgress: true,
        on: {
            progress() {
                const swiper = this;

                const parallaxFactor = 0.5;
                const parallaxOffset = swiper.width * parallaxFactor;

                swiper.slides.forEach((slide) => {
                    const parallaxTranslate = slide.progress * parallaxOffset;
                    const parallaxElement = slide.firstElementChild;

                    if (parallaxElement) {
                        parallaxElement.style.transform = `translate3d(${parallaxTranslate}px, 0, 0)`;
                    }
                });
            },
        },
    });
}
